import { IIxopayCheckoutProps } from "@kma-core/w2-w2w-payment-checkout";
import { AppRoutes } from "enums/routes.enum";
import { handleAmpliLoaded } from "helpers/handleAmpliLoaded";
import { createSearchParams, useNavigate } from "react-router-dom";
import { ampli, SubscriptionSubscribeClickedProperties } from "services/ampli";
import { ERROR_CODES } from "../constants";

type IIxopayResponseError = NonNullable<Parameters<IIxopayCheckoutProps["failureCallback"]>[0]>[0];

export const usePaymentResult = ({
    submitProps,
    declineQuery,
    successQuery,
}: {
    submitProps: Omit<SubscriptionSubscribeClickedProperties, "success">;
    declineQuery: Record<string, string>;
    successQuery: Record<string, string>;
}) => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        handleAmpliLoaded(() => ampli.subscriptionSubscribeClicked({ ...submitProps, success: true }));
        navigate({ pathname: AppRoutes.SUCCESS, search: createSearchParams({ ...successQuery, provider: "ixopay" }).toString() });
    };

    const handleDecline = (errors?: IIxopayResponseError[], callback?: (type?: string) => void) => {
        const mergedErrors = errors?.map((error) => error.errorMessage).join(" / ");
        handleAmpliLoaded(() => {
            ampli.subscriptionSubscribeClicked({ ...submitProps, success: false, reason: mergedErrors }), ampli.subscriptionErrorShown();
        });

        const codeToCategory: Record<string, string> = {};

        for (const [category, codes] of Object.entries(ERROR_CODES)) {
            codes.forEach((code) => {
                codeToCategory[code] = category;
            });
        }

        const matchedCategory = errors?.find((error) => codeToCategory[error.errorCode as unknown as string]);

        if (matchedCategory) {
            const category = codeToCategory[matchedCategory.errorCode as unknown as string];
            callback?.(category);
            return;
        }

        navigate({ pathname: AppRoutes.DECLINE, search: createSearchParams({ ...declineQuery, provider: "ixopay" }).toString() });
    };

    return { handleDecline, handleSuccess };
};
